import { ROUTES } from 'views/Configure/stubs';

const HOME = ROUTES.FEES_AND_INCENTIVES;

export default {
  HOME,
  UNIT_RESTOCKING_FEE: `${HOME}/unit-restocking-fee`,
  RETURN_PROCESSING_FEE: `${HOME}/return-processing-fee`
};
